import {Part} from "../part";
import {wallsThumbnail} from "../../../bvComponent/core/assets";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

import store from "../../../../store";
import LeftWall from "../subparts/walls/leftWall";
import RightWall from "../subparts/walls/rightWall";
import CenterWall from "../subparts/walls/centerWall";
import CeilingPanels from "../subparts/walls/ceilingPanels";

export default class Walls extends Part {
  static id = 'Walls';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Walls';
    this.translateId = "visualizer.bathroom.walls";
    this.partThumbnail = wallsThumbnail;

    // related items
    this.leftWall = null;
    this.rightWall = null;
    this.centerWall = null;
    this.popoutWall = null;
    this.ceiling = null;
    this.ceilingPanels = null;

    this.allWallsApplied = true;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Left Wall":
        relatedItemName = "leftWall";
        RelatedItemClass = LeftWall;
        break;
      case "Right Wall":
        relatedItemName = "rightWall";
        RelatedItemClass = RightWall;
        break;
      case "Center Wall":
        relatedItemName = "centerWall";
        RelatedItemClass = CenterWall;
        break;
      case "Ceiling Panels":
        relatedItemName = "ceilingPanels";
        RelatedItemClass = CeilingPanels;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts(withHidden = true) {
    return this.relatedItems
      .filter(item => {
        if (item.partId === "popout_wall") {
          item.visible = item.getParent().layout.getCurrentLayoutAbbreviation().includes("P")
        }
        return this.filterRelatedItem(item, withHidden)
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  handleSubPartClick() {

  }

  recoverPrevioslySelected(activeRelatedPart) {
    const {activeQuoteIndex} = store.getState().quotesState;
    this.relatedItems.forEach(relatedItem => {
      if (relatedItem.partId !== activeRelatedPart.partId && relatedItem.activeFeatureBeforeAllWalls) {
        if (relatedItem.activeFeatureBeforeAllWalls === "placeholder") {
          relatedItem.placeholderChanged = false;
          relatedItem.firstClick[activeQuoteIndex] = false;
        } else if (!relatedItem.selectedByUser) {
          relatedItem.activeFeatureBeforeAllWalls.clickFromAllWalls();
        }
      }
    });
  }

}
